const rv = [
	{ text: '', key: 'text.recordValidity.world', value: 1 },
	{ text: '', key: 'text.recordValidity.olympic', value: 2 },
	{ text: '', key: 'text.recordValidity.continent', value: 3 },
	{ text: '', key: 'text.recordValidity.national', value: 4 },
	{ text: '', key: 'text.recordValidity.region', value: 5 },
	{ text: '', key: 'text.recordValidity.district', value: 6 },
	{ text: '', key: 'text.recordValidity.area', value: 7 },
	{ text: '', key: 'text.recordValidity.club', value: 8 },
	{ text: '', key: 'text.recordValidity.stadion', value: 9 },
	{ text: '', key: 'text.recordValidity.meeting', value: 10 },
];

function getRecordValidity(_this) {
	rv.forEach((x) => {
		x.text = _this.$t(x.key);
	});
	return rv;
}

export default getRecordValidity;
